import React from "react";
import SettingsRoleManagement from "./views/SettingsRoleManagementPage";
import SettingsRoleManagementContent from "../../constants/contentFile.json";
import { SettingsRolesManagementContextProvider } from "./SettingsRoleManagementView";

const SettingsRoleManagementPage = () => {
  return (
    <SettingsRolesManagementContextProvider>
      <SettingsRoleManagement textContent={SettingsRoleManagementContent.settings} />
    </SettingsRolesManagementContextProvider>
  );
};

export default SettingsRoleManagementPage;
